import React, { useContext, useState } from 'react'
import TabElement from './TabElement';
import { Context } from '../../Context/Context';

function Tabs({tabs, activeTab, setActiveTab}) {

  const {notificationCount} = useContext(Context);
  
  let count = notificationCount;
  tabs.map((item) => item.name === "Notifications" ? item.count = count : 0);

  return (
         <div className='flex sticky font-medium mt-30 items-center w-full  bg-gray-100 z-10'>
          {
            tabs.map((item, key) => (
          
              <TabElement 
              activeTab={activeTab} 
              setActiveTab={setActiveTab} 
              id={key} 
              name={item.name}
              link={item.link}
              count = {item.count}
              onClick={() => {setActiveTab(key)}}
              />
            ))
          }
        </div>
  )
}

export default Tabs;